import { render, staticRenderFns } from "./search-hot.vue?vue&type=template&id=3b5c867d&scoped=true&"
import script from "./search-hot.vue?vue&type=script&lang=js&"
export * from "./search-hot.vue?vue&type=script&lang=js&"
import style0 from "./search-hot.vue?vue&type=style&index=0&id=3b5c867d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c867d",
  null
  
)

export default component.exports